import { createReducer, on } from '@ngrx/store';
import { Modulo, ModuloForm } from '@core/models';
import {
  MODULE_FIND_SUCCESS,
  MODULE_FAILURE,
  MODULE_UPDATE_FORM,
  MODULE_RESET_ERROR,
  MODULE_RESET,
  MODULE_RESET_FORM,
  MODULE_FIND_ALL_SUCCESS,
  MODULE_EDIT_MODE,
  MODULE_CLEAR_STATE,
  MODULE_UPDATE_LOADING,
  MODULE_UPDATE_ID,
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformModuleData } from '@core/helpers';

export interface ModuleState {
  loading: boolean;
  moduleList: Modulo[];
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  moduleForm: ModuloForm | null;
  moduleId: string | null;
  module: Modulo | null;
}

export const initialState: ModuleState = {
  loading: false,
  moduleList: [],
  error: null,
  editMode: false,
  isEditing: false,
  moduleForm: null,
  moduleId: null,
  module: null,
};

export const moduleReducer = createReducer(
  initialState,
  on(MODULE_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(MODULE_FIND_SUCCESS, (state, { module }) => ({ ...state, module: transformModuleData(module) })),
  on(MODULE_FIND_ALL_SUCCESS, (state, { moduleList }) => ({ ...state, moduleList })),
  on(MODULE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(MODULE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(MODULE_UPDATE_FORM, (state, { moduleForm }) => ({ ...state, moduleForm: { ...state.moduleForm, ...moduleForm } })),
  on(MODULE_UPDATE_ID, (state, { moduleId }) => ({ ...state, moduleId })),
  on(MODULE_RESET, (state) => ({ ...state, module: null, moduleId: null, moduleForm: null })),
  on(MODULE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(MODULE_RESET_FORM, (state) => ({ ...state, moduleForm: null, loading: false })),
  on(MODULE_CLEAR_STATE, (state) => ({ ...initialState, loading: state.loading })),
);
